define('v3/Pages/Check/Components/CheckClassGrid/ViewModels/CheckClass.ViewModel',[
	'knockout',
	'lodash',
	'v3/Common/Services/boundaryPercentileService',
	'v3/Common/Models/enums'
], function (ko, _, boundaryPercentileService, enums) {
	function CheckClassViewModel (pupil, subjectPercentileModel, targetAbilityPercentile) {
		var self = this;

		subjectPercentileModel = subjectPercentileModel || { percentile: 0, abilityPercentileState: enums.abilityPercentileState.notStarted };

		var legendType = boundaryPercentileService.getLegendTypeByPercentile(subjectPercentileModel.percentile);

		this.pupilId = pupil.pupilId;
		this.pupilName = pupil.longName;
		this.pupilShortName = pupil.shortName;

		this.pupilNameForSorting = pupil.pupilNameForSorting;

		this.pupilFromAnotherClass = pupil.pupilFromAnotherClass;
		this.actualClassName = pupil.actualClassName;

		this.abilityPercentile = subjectPercentileModel.percentile;
		this.abilityPercentileState = subjectPercentileModel.abilityPercentileState;
		this.targetAbilityPercentile = targetAbilityPercentile;

		this.abilityDisplayName = (this.abilityPercentile != null && legendType)
			? legendType.name + ' (' + this.abilityPercentile + '%)' : '';

		this.abilityPercentileNumeral = (this.abilityPercentile != null && legendType)
			? legendType.legendNumeral : '';

		this.abilityPercentileLevel = (this.abilityPercentile != null && legendType)
			? legendType.legendType : '';

		self.abilityGrowth = null;
		self.targetAbilityGrowth = null;
		self.currentscore = null;
		self.actualGrowth = ko.observable(null);
		self.expectedGrowth = ko.observable(null);
		self.score = ko.observable(null);
		self.isDLEVisible = ko.observable(false);
		self.pupilDAE = ko.observable(null);
		self.abilityObjectType = ko.observable(enums.chartLevel.allpupils);
		self.isRainBowChartLoaded = ko.observable(false);

		// Chart data
		self.abilityObjectType = ko.observable(enums.chartLevel.allpupils);

		this.updatePupilAbilityGrowth = function (pupilAbilityGrowth) {
			if (_.isFinite(pupilAbilityGrowth.score)) {
				self.currentscore = pupilAbilityGrowth.score; // Actual current score
				self.score(pupilAbilityGrowth.score);
			} else {
				self.abilityGrowth = pupilAbilityGrowth.abilityGrowth; // Actual current Growth
				self.targetAbilityGrowth = pupilAbilityGrowth.targetAbilityGrowth; // Target Growth
				self.actualGrowth(pupilAbilityGrowth.abilityGrowth);
				self.expectedGrowth(pupilAbilityGrowth.targetAbilityGrowth);
			}
		};

		// The below values are normalised acorss the whole screen for display purposes
		this.abilityGrowthPercent = null; // for bar display purposes
		this.targetAbilityGrowthPercent = null; // for bar display purposes
	}

	return CheckClassViewModel;
});
